export function generarMensajeWhatsApp({ modeloLabel, cuotasElegidas, infoCuota, valorUF }) {
    const ufTotal = parseFloat(infoCuota.uf_total.replace(",", "."));
    const mensualUF = (ufTotal / cuotasElegidas).toFixed(1);
    const mensualCLP = Math.round(mensualUF * valorUF).toLocaleString("es-CL");

    return `
Buen día, estoy interesado/a en una simulación de crédito:
    Modelo: ${modeloLabel}
    Cuotas: ${cuotasElegidas}
    Total en UF: ${ufTotal.toFixed(1)}
    Mensual en UF: ${mensualUF}
    Mensual en CLP: $${mensualCLP}
    ¡Quiero que me contacten para más detalles, gracias!
    `.trim();
}

export function abrirWhatsApp(numero, mensaje) {
    const encoded = encodeURIComponent(mensaje);
    const url = `https://wa.me/${numero}?text=${encoded}`;
    window.open(url, "_blank");
}
